module.exports = __webpack_public_path__ + "img/5.3203d6e7.png";